export const adinkraSymbols = [
  {
    id: 'gye-nyame',
    name: 'Gye Nyame',
    translation: 'Except God',
    symbol: '✦',
    image: '/images/adinkra-symbol-page/adinkra.webp',
    category: 'Spirituality',
    meaning: 'The omnipotence, omniscience, and immortality of God. The most widely used Adinkra symbol — it reflects the Akan belief that no one lives who has seen the beginning or end of existence, except God.',
    usage: 'Worn as an expression of faith and dependence on the divine. Found on clothing, jewelry, and architecture across Ghana.',
    attributes: ['Faith', 'Divine Power', 'Humility before God'],
  },
  {
    id: 'sankofa',
    name: 'Sankofa',
    translation: 'Return and get it',
    symbol: '↩',
    image: '/images/adinkra-symbol-page/sankofa.webp',
    category: 'Wisdom',
    meaning: 'The wisdom of learning from the past. Represented by a bird looking backward while flying forward — it is not wrong to go back and reclaim what you have forgotten. Deeply meaningful for the African diaspora.',
    usage: 'Inspires reconnection with cultural roots and ancestral wisdom. Ubiquitous in diaspora communities worldwide.',
    attributes: ['Wisdom', 'Cultural Identity', 'Learning from History'],
  },
  {
    id: 'adinkrahene',
    name: 'Adinkrahene',
    translation: 'Chief of Adinkra symbols',
    symbol: '◎',
    image: '/images/adinkra-symbol-page/Adinkrahene.webp',
    category: 'Leadership',
    meaning: 'Greatness, charisma, and leadership. Concentric circles represent the king at the centre of all things, his authority radiating outward to his people. It is said to have inspired all other Adinkra symbols.',
    usage: 'Symbol of leadership, royalty, and the central authority of a great ruler.',
    attributes: ['Greatness', 'Charisma', 'Leadership'],
  },
  {
    id: 'akoma',
    name: 'Akoma',
    translation: 'Heart',
    symbol: '♥',
    category: 'Character',
    meaning: 'Patience, goodwill, faithfulness, and love. The heart beats continuously without rest — representing perseverance and the ability to maintain composure and love even through difficulty.',
    usage: 'Used in weddings, love ceremonies, and as a reminder to be patient in difficult times.',
    attributes: ['Patience', 'Love', 'Tolerance', 'Faithfulness'],
  },
  {
    id: 'aya',
    name: 'Aya',
    translation: 'Fern',
    symbol: '🌿',
    category: 'Resilience',
    meaning: 'Endurance and resourcefulness. The fern thrives in difficult environments where other plants cannot, symbolising the ability to survive and flourish under the most challenging conditions.',
    usage: 'Worn by those who have endured hardship and persevered against the odds.',
    attributes: ['Endurance', 'Resourcefulness', 'Defiance of hardship'],
  },
  {
    id: 'fawohodie',
    name: 'Fawohodie',
    translation: 'Independence',
    symbol: '⊕',
    image: '/images/adinkra-symbol-page/Fawohodie.webp',
    category: 'Freedom',
    meaning: 'Freedom, emancipation, and independence. This symbol speaks directly to liberation from slavery, oppression, or any form of bondage. It is among the most powerful symbols for the African diaspora experience.',
    usage: 'Symbol of liberation movements, personal emancipation, and the ongoing pursuit of freedom.',
    attributes: ['Freedom', 'Emancipation', 'Independence', 'Sovereignty'],
  },
  {
    id: 'dwennimmen',
    name: 'Dwennimmen',
    translation: "Ram's horns",
    symbol: '♈',
    image: '/images/adinkra-symbol-page/Dwennimmen.webp',
    category: 'Character',
    meaning: 'Humility together with strength. The ram fights fiercely in battle yet bows its head humbly when drinking water. This teaches that true power must be tempered by humility.',
    usage: 'Used to remind leaders and warriors that strength without humility is dangerous.',
    attributes: ['Humility', 'Strength', 'Wisdom in power'],
  },
  {
    id: 'ese-ne-tekrema',
    name: 'Ese Ne Tekrema',
    translation: 'Teeth and tongue',
    symbol: '⊞',
    image: '/images/adinkra-symbol-page/Ese Ne Tekrema.webp',
    category: 'Relationships',
    meaning: 'Friendship and interdependence. Though teeth and tongue sometimes clash, they must cooperate. Represents the importance of maintaining relationships despite occasional conflict.',
    usage: 'Used to symbolise unity, partnership, and the lifelong value of friendship.',
    attributes: ['Friendship', 'Unity', 'Interdependence'],
  },
  {
    id: 'nkyinkyim',
    name: 'Nkyinkyim',
    translation: 'Twisting',
    symbol: '∿',
    image: '/images/adinkra-symbol-page/Nkyinkyim.webp',
    category: 'Character',
    meaning: 'Adaptability, dynamism, and versatility. The twisting form represents the ability to adapt to changing circumstances while maintaining one\'s core identity and values.',
    usage: 'Worn by those who are versatile and resourceful in navigating life\'s changing terrain.',
    attributes: ['Adaptability', 'Dynamism', 'Versatility'],
  },
  {
    id: 'nyame-biribi',
    name: 'Nyame Biribi Wo Soro',
    translation: 'God is in the heavens',
    symbol: '✴',
    image: '/images/adinkra-symbol-page/Nyame Biribi Wo Soro.webp',
    category: 'Spirituality',
    meaning: 'Hope. A reminder that no matter how difficult life becomes, God\'s grace is always present and available. It gives hope to the hopeless and faith to the faithless.',
    usage: 'Worn as a daily reminder of divine hope and the ever-present grace of God.',
    attributes: ['Hope', 'Faith', 'Divine Grace'],
  },
  {
    id: 'osram-ne-nsoromma',
    name: 'Osram Ne Nsoromma',
    translation: 'Moon and star',
    symbol: '☽',
    category: 'Relationships',
    meaning: 'Love, faithfulness, and harmony. The moon and star are inseparable — wherever the moon goes, the star follows. Represents devotion and faithfulness in love and marriage.',
    usage: 'Used in weddings and romantic relationships as a symbol of eternal companionship.',
    attributes: ['Love', 'Faithfulness', 'Harmony', 'Devotion'],
  },
  {
    id: 'pempamsie',
    name: 'Pempamsie',
    translation: 'Sew in readiness',
    symbol: '⊟',
    image: '/images/adinkra-symbol-page/Pempamsie.webp',
    category: 'Preparedness',
    meaning: 'Readiness and preparedness. Like a garment sewn before it is needed, this symbol teaches the importance of always anticipating what is to come and being ready for any situation.',
    usage: 'Worn by warriors, leaders, and those in positions of responsibility who must always be prepared.',
    attributes: ['Readiness', 'Preparedness', 'Vigilance', 'Foresight'],
  },
  {
    id: 'mpatapo',
    name: 'Mpatapo',
    translation: 'Knot of reconciliation',
    symbol: '✿',
    image: '/images/adinkra-symbol-page/Mpatapo.webp',
    category: 'Peace',
    meaning: 'Peace, reconciliation, and pacification. The interlocked design represents the tying together of parties in conflict. It is the work of peacemakers — those who bind wounds and restore harmony.',
    usage: 'Used in reconciliation ceremonies, peace negotiations, and as a symbol of the peacemaker\'s sacred duty.',
    attributes: ['Peace', 'Reconciliation', 'Harmony', 'Forgiveness'],
  },
  {
    id: 'funtunfunefu',
    name: 'Funtunfunefu',
    translation: 'Siamese crocodiles',
    symbol: '⊗',
    image: '/images/adinkra-symbol-page/Funtunfunefu.webp',
    category: 'Unity',
    meaning: 'Democracy and unity in diversity. Two crocodiles share one stomach yet compete for food — symbolising the foolishness of internal conflict when all benefit from cooperation and unity.',
    usage: 'Represents democracy, unity, and the common destiny of a people who must cooperate to survive.',
    attributes: ['Democracy', 'Unity', 'Cooperation', 'Common destiny'],
  },
  {
    id: 'bese-saka',
    name: 'Bese Saka',
    translation: 'Sack of kola nuts',
    symbol: '❋',
    image: '/images/adinkra-symbol-page/Bese Saka.webp',
    category: 'Prosperity',
    meaning: 'Affluence, power, abundance, and unity. Kola nuts were once used as currency and offered at ceremonies. A sack represents great wealth and the generosity to share it with others.',
    usage: 'Worn as a symbol of success, abundance, and the responsibility that comes with prosperity.',
    attributes: ['Affluence', 'Abundance', 'Power', 'Generosity'],
  },
  {
    id: 'hye-won-hye',
    name: 'Hye Won Hye',
    translation: 'That which does not burn',
    symbol: '❖',
    image: '/images/adinkra-symbol-page/Hye Won Hye.webp',
    category: 'Resilience',
    meaning: 'Imperishability and endurance. Like something that cannot be consumed by fire, this symbol represents the indestructible nature of the soul and the power to survive any trial or persecution.',
    usage: 'Worn as a symbol of invincibility and the endurance of the human spirit through hardship.',
    attributes: ['Imperishability', 'Endurance', 'Invincibility'],
  },
  {
    id: 'nyame-dua',
    name: 'Nyame Dua',
    translation: "God's tree / God's altar",
    symbol: '✠',
    image: '/images/adinkra-symbol-page/Nyame Dua.webp',
    category: 'Spirituality',
    meaning: 'Divine protection and the presence of God. The Nyame Dua is a wooden altar post planted as a shrine to the Supreme God, representing the sacred connection between earth and the divine.',
    usage: 'Planted at entrances of homes and villages for protection and divine blessing.',
    attributes: ['Divine Protection', 'Spiritual Presence', 'Sacred Space'],
  },
  {
    id: 'sunsum',
    name: 'Sunsum',
    translation: 'Spirit / Soul',
    symbol: '✺',
    image: '/images/adinkra-symbol-page/Sunsum.webp',
    category: 'Spirituality',
    meaning: 'Spirituality and the personal soul. In Akan cosmology the Sunsum is the individual spirit that animates a person — distinct from the Kra (divine soul given by God). It represents one\'s unique spiritual essence.',
    usage: 'Used in spiritual contexts to invoke and honour the individual soul and its divine purpose.',
    attributes: ['Spirituality', 'Soul', 'Inner Essence', 'Personal Spirit'],
  },
  {
    id: 'akoben',
    name: 'Akoben',
    translation: 'War horn',
    symbol: '📯',
    image: '/images/adinkra-symbol-page/Akoben.webp',
    category: 'Leadership',
    meaning: 'Vigilance and wariness. The war horn is sounded to call warriors to battle — representing the call to action, alertness, and the importance of never being caught unprepared.',
    usage: 'Worn by warriors and leaders as a constant call to vigilance and decisive action.',
    attributes: ['Vigilance', 'Wariness', 'Call to Action', 'Leadership'],
  },
  {
    id: 'akoma-ntoso',
    name: 'Akoma Ntoso',
    translation: 'Linked hearts',
    symbol: '❤',
    image: '/images/adinkra-symbol-page/Akoma Ntoso.webp',
    category: 'Relationships',
    meaning: 'Understanding and agreement. When hearts are linked, there is unity of purpose and mutual understanding between people. It represents the bond of community and shared vision.',
    usage: 'Used to represent deep communal bonds, family unity, and the shared heart of a people.',
    attributes: ['Understanding', 'Unity', 'Community', 'Shared purpose'],
  },
];

export const adinkraCategories = ['All', 'Spirituality', 'Wisdom', 'Leadership', 'Character', 'Resilience', 'Freedom', 'Relationships', 'Peace', 'Unity', 'Prosperity', 'Preparedness'];
